import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
    root: {
      height: 35,
    },
    size: {
      width: 40,
      height: 25,
    },
  });
  export default useStyles